<script lang="ts" setup>
import { computed, ref } from 'vue';
import type { Assignee } from 'src/types/ticket-type';

const mechanics = ref<Assignee[]>([]);


const search = ref('');

const filteredMechanics = computed(() =>
  mechanics.value.filter((mechanic) =>
    mechanic.name.toLowerCase().includes(search.value.toLowerCase())));

const sortedMechanics = computed(() =>
  filteredMechanics.value.slice().sort((a, b) => a.workload - b.workload));

function selectMechanic (mechanic: Assignee) {
  // this.$emit('select', mechanic);
}

function getWorkloadPercentage (workload) {
  // Convert workload hours to percentage based on a maximum capacity of 40 hours per week
  const percentage = (workload / 40) * 100;

  // round percentage to full number
  return Math.round(percentage);
}

function getWorkloadSeverity (workload) {
  // Determine the tag severity based on workload
  if (workload > 40) return 'danger';
  if (workload > 30) return 'warning';
  return 'success';
}

</script>

<template>
  <div class="mechanic-picker">
    <div class="grid ai-center mb-3">
      <div class="col">
        <InputText
          v-model="search"
          placeholder="Search by name..."
        />
      </div>
    </div>
    <div
      v-for="mechanic in sortedMechanics"
      :key="mechanic.id"
      class="p-2 border-1 mt-2 surface-border"
    >
      <div class="grid align-items-center">
        <div class="col-10">
          <div class="flex justify-content-between">
            <div>
              <span class="font-bold">{{ mechanic.name }}</span>
            </div>

            <div>
              <Tag
                :severity="getWorkloadSeverity(mechanic.workload)"
                class="mr-2"
              >
                {{ mechanic.workload }} Hours
              </Tag>
              <!-- <Tag
                :severity="getWorkloadSeverity(mechanic.workload)"
                class="mr-2"
              >
                {{ mechanic.ticketsAssigned }} Tickets
              </Tag> -->
            </div>
          </div>
          <!--
          <Accordion
            class="py-2"
          >
            <AccordionTab
              header="Unavailable dates"
              :pt="{
                headerAction: 'p-2',
              }"
            >
              <div
                v-for="day in mechanic.availability"
                :key="day.date.toString()"
              >
                <div v-if="!day.isAvailable">
                  <i
                    class="pi pi-calendar-times"
                  />
                  <span class="ml-2">{{ getDateDutchFormat(day.date) }}</span>
                </div>
              </div>
            </AccordionTab>
          </Accordion> -->
          <ProgressBar
            class="mt-2"
            :value="getWorkloadPercentage(mechanic.workload)"
            show-value
          />

        <!-- Select button but small -->
        </div>
        <div class="col-2 flex justify-content-start">
          <Button
            icon="pi pi-check"
            icon-pos="right"
            size="small"
            :pt="{
              icon: 'p-button-rounded p-button-text',
            }"
            outlined
            @click="selectMechanic(mechanic)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mechanic-picker .card {
  transition: box-shadow .2s;
  cursor: pointer;
}

.mechanic-picker .card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
</style>
